var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "header",
    {
      staticClass: "d-flex border-bottom",
      on: { click: _setup.formScrollTop },
    },
    [
      _c(
        "div",
        { staticClass: "flex-fill d-flex align-items-center" },
        [
          _c(_setup.ShowSiteTreeBtn, {
            attrs: {
              "table-name": _setup.tableName,
              id: _setup.id,
              "site-tree-id": "siteTreeOffcanvas",
            },
          }),
          _vm._v(" "),
          _setup.show
            ? _c(_setup.FormAddBtn, { attrs: { "form-id": _vm.formId } })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.FormDisplayTitle, { attrs: { "form-id": _vm.formId } }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSaveBtn
        ? _c(_setup.FormSaveBtn, {
            staticClass: "rounded-0",
            attrs: { "form-id": _vm.formId },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSaveAndCloseBtn
        ? _c(_setup.FormSaveCloseBtn, { attrs: { "form-id": _vm.formId } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }